var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3332 13.3333C13.0696 13.3333 13.6665 12.7364 13.6665 12C13.6665 11.2636 13.0696 10.6667 12.3332 10.6667C11.5968 10.6667 10.9999 11.2636 10.9999 12C10.9999 12.7364 11.5968 13.3333 12.3332 13.3333Z",
    fill: "#4C545B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3332 8.66667C13.0696 8.66667 13.6665 8.06971 13.6665 7.33333C13.6665 6.59695 13.0696 6 12.3332 6C11.5968 6 10.9999 6.59695 10.9999 7.33333C10.9999 8.06971 11.5968 8.66667 12.3332 8.66667Z",
    fill: "#4C545B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3332 18C13.0696 18 13.6665 17.403 13.6665 16.6667C13.6665 15.9303 13.0696 15.3333 12.3332 15.3333C11.5968 15.3333 10.9999 15.9303 10.9999 16.6667C10.9999 17.403 11.5968 18 12.3332 18Z",
    fill: "#4C545B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDots);
export default __webpack_public_path__ + "static/media/EditDots.dc476f99f9d5f78db5ab28df14857974.svg";
export { ForwardRef as ReactComponent };